import { SVGProps } from "./svg.types"

const Chevron = ({ className }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={className}
  >
    <g clipPath="url(#clip0_8978_2494)">
      <path
        fill="var(--chevron-fill-color)"
        d="M9.777 17.738a.895.895 0 01-1.34-1.18l.075-.085L12.985 12 8.512 7.527a.895.895 0 01-.074-1.18l.074-.085a.895.895 0 011.18-.074l.085.074 5.106 5.105c.322.323.347.83.074 1.181l-.075.085-5.105 5.105z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_8978_2494">
        <path fill="#fff" d="M0 0H12V12H0z" transform="translate(6 6)"></path>
      </clipPath>
    </defs>
  </svg>
)
export { Chevron }
